import React, { useContext, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {
  Button,
  Layout,
  MobileTabBar,
  Footer,
  Accordion,
  Input,
  Select,
  SelectFile,
} from '../../components';

import './support.less';
import '../Profile/profile-general.less';
import '../../components/Card/card.less';

import RightChevronIcon from '../../assests/icons/right-chevron.icon';
import { Tabs, Modal, Form } from 'antd';
import { DimensionsContext } from '../../context/dimensions.context';
import ContactUs from 'components/ContactUs/contactus';

const { TabPane } = Tabs;

const AccordionList = [
  {
    header: 'Mesaj başlığı alabilmek için hangi evraklarla başvurmak gerekir?',
    content:
      '<p>&Uuml;nvan kriterleri:</p> <ol style="list-style-type: lower-alpha;"> <li>Firmanın &uuml;nvanı ile uygun olması.</li> <li>Firmanın ilgili evraklarla ispatlaması koşulu ile tescilli markası olması</li> <li>Boşluk dahil 11 karakteri ge&ccedil;memesi;</li> <li>Yer ismi, &ouml;zel isim, cins isim, sıfat, eylem, genel anlam ifade eden jenerik kelimeler olmaması</li> <li>İsim soyisim taleplerinde sadece evrakla ispatlanması koşulu ile firma sahibinin isim soyismi olması</li> <li>İ3-4-5 haneli kısa numara olacak şekilde alfanumerik tanımı yapılamaz.</li> </ol> <p>&Uuml;nvan tanımı i&ccedil;in gerekli belgeler:</p> <p>BTK tarafından yayınlanan CLI y&ouml;netmeliği kapsamında &uuml;nvan tanımları i&ccedil;in gerekli belgeler şu şekildedir:</p> <ol style="list-style-type: lower-alpha;"> <li>Alfanumerik Başlık(lar)ın G&ouml;nderici ad-soyadı olması halinde kimlik belgesini, unvanı olması halinde kimlik belgesi ile birlikte unvanı ispatlayıcı belgeyi ve Turkcell tarafından doğrulanmak kaydı ile E-devlet kapısında &uuml;rettiği yerleşim yeri belgesi</li> <li>Alfanumerik Başlık(lar)ın Firma &uuml;nvanı olması halinde, T&uuml;rkiye Cumhuriyeti kanunlarına g&ouml;re kurulmuş talebi ileten şirket tarafından imzalı ve kaşeli Ticaret Sicil Gazetesi &ouml;rneği veya Ticaret Sicil Kaydı veya unvanı ispatlayıcı diğer resmi belgeler,</li> <li>Alfanumerik Başlık(lar)ın Kamu kurum ve kuruluş unvanı olması halinde, ilgili Kamu kurum ve kuruluşundan alınmış resmi belge,</li> <li>Alfanumerik Başlık(lar)ın Sivil toplum kuruluşu unvanı olması halinde, ilgili sivil toplum kuruluşundan alınmış belge,</li> <li>Alfanumerik Başlık(lar)ın Marka adı i&ccedil;ermesi halinde, marka sahipliğini ispatlayıcı belge,</li> <li>Alfanumerik Başlık(lar)ın, Bayiliği veya temsilciliği yapılan bir firma veya kuruluş adını i&ccedil;ermesi halinde, ilgili firma veya kuruluş izninin alındığını ispatlayıcı belge, (Yurtdışı firmalarla yapılmış anlaşmalara istinaden iletilen belgelerin noter onaylı terc&uuml;me edilmiş versiyonları iletilmelidir.)</li><li>Alfanumerik Başlık(lar)ın işbu fıkrada yer almayan şekillerde kullanımı halinde, gerekli g&ouml;r&uuml;lebilecek ispatlayıcı belge</li> </ol>',
  },
  {
    header: 'İleri tarihli mesaj atabilir miyim?    ',
    content:
      'Evet. Saat 09:00-21:00 saatleri arasında olacak şekilde ileri tarihli mesaj atılabilir.      ',
  },
  {
    header: 'Hangi saatler arasında SMS gönderebilirim?    ',
    content:
      '09:00-21:00 saatleri arasında SMS gönderimi yapabilirsiniz.      ',
  },
  {
    header: 'Mesaj Üssü üzerinden gönderilen mesaj içerikleri daha sonra görülebilir mi?    ',
    content:
      'Gönderim menüsünde müşteri daha önceden yapmış olduğu gönderimleri görebilir. Bu ekranda her bir gönderim için gönderim raporu excel formatında indirilebilir. İndirilen raporda içerik bilgisi de görüntülenebilir.      ',
  },
  {
    header: 'İletilmeyen mesajlar için ücret ödeyecek miyim?    ',
    content:
      "Mesaj Üssü'nde yapılan SMS gönderimleri son kullanıcının telefonunun kapalı olması, şebeke yoğunluğu vb. sebeplerden ötürü ulaşamazsa, sistem 28,5 saat boyunca mesajları iletmeye çalışmaya devam eder. 28,5 saatin sonunda iletilemeyen mesajlar 'başarısız' statüsüne düşer ve bu gönderimler için kullanılan krediler müşterinin hesabına otomatik olarak geri yüklenir.ZİM (MMS) gönderimlerinde ise son kullanıcının telefonunun MMS ayarlarının yapılı olmaması, diğer operatörlerin herhangi bir sebepten ötürü MMS mesajını son kullanıcıya iletememesi vb. sebeplerden ötürü MMS son kullanıcının telefonunda gözükmeyebilir. Bu gibi durumlarda Turkcell'in bir kontrol imkanı olmadığından ötürü MMS, Mesaj Üssü sisteminden başarılı olarak çıktığı anda ücretlendirme yapılır ve geri yükleme yapılmaz.      ",
  },
  {
    header: 'Latin alfabesi dışında farklı alfabelerle mesaj gönderilebilir mi?    ',
    content:
      'Hayır. Sadece Latin alfabesi ile mesaj gönderilebilir.      ',
  }
];

const SupportShippingTransactions = () => {
  const [modalSendUs, setModalSendUs] = useState(false);
  const { isTabletBig } = useContext(DimensionsContext);
  const [form] = Form.useForm();

  let history = useHistory();

  function onChangeTabs(key) {
    if (key == 1) {
      history.push('./CreditPurchaseHelp');
    } else if (key == 2) {
      history.push('./MessagesHelp');
    } else if (key == 3) {
      history.push('./ReportsHelp');
    } else if (key == 4) {
      history.push('./AccountsHelp');
    }
  }

  return (
    <Layout>
      <div className="profile-page support">
        <div className="container">
          <div className="profile-page__title">
            <h1 className="section__title">Yardım</h1>
          </div>
          <div className="content-wrapper">
            {isTabletBig ? (
              <div className="profile-page__menu sub-groups">
                <h2 className="box__title">Yardım Konuları</h2>
                <ul>
                  <li>
                    <NavLink
                      to="./CreditPurchaseHelp"
                      classname="active"
                      activeClassName="active"
                    >
                      <span>Kredi Satın Alımı</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="./MessagesHelp"
                      activeClassName="active"
                    >
                      <span>Gönderim İşlemleri</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="./ReportsHelp" activeClassName="active">
                      <span>Raporlar</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="./AccountsHelp" activeClassName="active">
                      <span>Şirket ve Hesaplar</span>
                      <RightChevronIcon />
                    </NavLink>
                  </li>
                </ul>
                <div className="write-us">
                  <span>Sorularınıza yanıt alamadınız mı?</span>
                  <Button
                    type="primary"
                    shape="round"
                    onClick={() => setModalSendUs(true)}
                  >
                    Bize Yazın
                  </Button>
                </div>
              </div>
            ) : (
              <Tabs
                defaultActiveKey="1"
                onChange={onChangeTabs}
                renderTabBar={(props, Item) => {
                  return <MobileTabBar props={props} item={Item} />;
                }}
              >
                <TabPane tab="Kredi Satın Alımı" key="1"></TabPane>
                <TabPane tab="Gönderim İşlemleri" key="2"></TabPane>
                <TabPane tab="Raporlar" key="3"></TabPane>
                <TabPane tab="Şirket ve Hesaplar" key="4"></TabPane>
              </Tabs>
            )}
            <div className="profile-page__content">
              <Accordion list={AccordionList} />
            </div>
            {!isTabletBig ? (
              <div className="write-us">
                <span>Sorularınıza yanıt alamadınız mı?</span>
                <Button
                  type="primary"
                  shape="round"
                  onClick={() => setModalSendUs(true)}
                >
                  Bize Yazın
                </Button>
              </div>
            ) : null}
          </div>
          {modalSendUs &&  (
      <ContactUs visible={modalSendUs} onClose={e=> setModalSendUs(false)}  onOpen={e=> setModalSendUs(true)}  />)}
        </div>
      </div>
      <Footer />
    </Layout>
  );
};

export default SupportShippingTransactions;
